function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M34.8 0H1.2C0.537258 0 0 0.537258 0 1.2V22.8C0 23.4627 0.537258 24 1.2 24H34.8C35.4627 24 36 23.4627 36 22.8V1.2C36 0.537258 35.4627 0 34.8 0Z",
  fill: "white"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.36205 11.8008C8.36205 7.18771 12.0985 3.44812 16.7076 3.44812C21.3168 3.44812 25.0533 7.18771 25.0533 11.8008C25.0533 16.4139 21.3168 20.1536 16.7076 20.1536C12.0985 20.1536 8.36205 16.4139 8.36205 11.8008Z",
  fill: "#FFFFFE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7548 11.6362C21.7514 9.49724 20.4155 7.673 18.5331 6.95054V16.3216C20.4155 15.5982 21.7514 13.7756 21.7548 11.6362ZM14.9421 16.3197V6.95148C13.0614 7.67617 11.7275 9.4978 11.7225 11.6362C11.7275 13.7741 13.0614 15.5955 14.9421 16.3197ZM16.7385 3.71555C12.3679 3.71723 8.82687 7.26193 8.82612 11.6362C8.82687 16.01 12.3679 19.5541 16.7385 19.5549C21.1092 19.5541 24.6509 16.01 24.6521 11.6362C24.6509 7.26193 21.1092 3.71723 16.7385 3.71555ZM16.7191 20.3024C11.9364 20.3251 8 16.4472 8 11.7266C8 6.56747 11.9364 2.99907 16.7191 3H18.9604C23.6866 2.99907 28 6.56579 28 11.7266C28 16.4455 23.6866 20.3024 18.9604 20.3024H16.7191Z",
  fill: "#0167AA"
});

function SvgDinersClub({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/dinersClub.3d8d2c1a.svg";
export { ForwardRef as ReactComponent };